import { createContext } from 'react';

const LanguageContext = createContext('ru');

export default LanguageContext;
